import React, {useEffect, useMemo, useState} from 'react';

import {filter, isEmpty} from 'lodash';
import {useParams} from 'react-router';
import {components} from 'react-select';

import {getPublicAccreditationBodiesByCb} from 'api/accreditation-bodies';
import {SelectAsyncBase} from 'components/Forms/FormBases';

import styles from './styles.module.scss';

SelectPublicABCB.defaultProps = {
  isAuth: false,
  isClearable: true,
  cacheOptions: true,
  defaultOptions: true,
  placeholder: 'Select AB',
  onChange: () => {},
  getOptionLabel: (option) => {
    const {accreditation_bodies_name, accreditation_bodies_acronym} = option;
    const abAcronym = accreditation_bodies_acronym
      ? `(${accreditation_bodies_acronym})`
      : '';
    const abName = filter([accreditation_bodies_name, abAcronym]).join(' ');

    return abName;
  },
  getOptionValue: (option) => option.accreditation_bodies_id,
};

const MenuList = (props, extraProps) => {
  const {children} = props;
  const {isAuth, toggle} = extraProps;

  return (
    <components.MenuList {...props} className="p-0">
      {children}
      {!isAuth && (
        <div className={styles['load-more']} onClick={toggle}>
          <p>Load More</p>
        </div>
      )}
    </components.MenuList>
  );
};

function SelectPublicABCB(props) {
  const {value, isAuth, toggle, onChange, selected, ...rest} = props;

  const {cbId} = useParams();

  const [first, setFirst] = useState(null);

  const menuListProps = {
    isAuth,
    toggle,
  };

  useEffect(() => {
    if (!!first) onChange(first);
  }, [first]);

  async function getOptions(inputValue) {
    const query = {
      search: inputValue,
      limit: isAuth ? -1 : 4,
    };

    try {
      const {data} = await getPublicAccreditationBodiesByCb(cbId, query);

      if (!isEmpty(data) && !inputValue) {
        setFirst(data[0]);
      }

      return data;
    } catch (error) {
      return [];
    }
  }

  return useMemo(
    () => (
      <SelectAsyncBase
        value={selected}
        onChange={onChange}
        defaultValue={first}
        reloadDependency={isAuth}
        loadOptions={getOptions}
        components={{
          ClearIndicator: () => null,
          IndicatorSeparator: () => null,
          MenuList: (props) => MenuList(props, menuListProps),
        }}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: '#0087d3',
          },
        })}
        {...rest}
      />
    ),
    [selected, first, isAuth, getOptions]
  );
}

export default SelectPublicABCB;
